import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AppLoginComponent } from '@adw/src/app/components/login/app-login.component';

import { WkAuthenticationService } from '../../services/wk-authentication.service';
import { WkAppConfigService } from '../../services/wk-app-config.service';
import { WINDOW_TOKEN } from '../shared/window.token';

@Component({
  selector: 'wk-login',
  templateUrl: './wk-login.component.html',
  styleUrls: ['./wk-login.component.scss'],
  standalone: false,
})
export class WkLoginComponent extends AppLoginComponent implements OnInit {
  public isFailed = false;
  public ssoEnabled: boolean;
  public successRoute: string;

  constructor(
    private readonly auth: WkAuthenticationService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly config: WkAppConfigService,
    @Inject(WINDOW_TOKEN) private readonly window: Window
  ) {
    super();
  }

  public ngOnInit(): void {
    this.ssoEnabled = this.auth.isSsoEnabled();
    this.successRoute = this.config.get<string>('successRoute') || 'dashboard';
    if (this.auth.isLoggedIn()) {
      this.router.navigate(['/']);
    } else if (this.ssoEnabled) {
      this.auth?.invalidateSsoSession();
    }
    this.isFailed = this.route.snapshot.queryParamMap.has('error');
  }

  public loginViaSso(): void {
    this.auth.initSsoSession();
    const ssoUrl = this.getSsoLoginUrl();
    this.window.location.href = ssoUrl;
  }

  private getSsoLoginUrl(): string {
    const errorUrl = this.buildUrl('/login?error');
    const redirectUrl =
      this.route.snapshot.queryParamMap.get('redirectUrl') || this.successRoute;
    const successUrl = this.buildUrl(redirectUrl);

    // Use proxy path (will be routed to wkSsoUrl by webpack dev server or nginx)
    return `/.sso/login?success=${encodeURIComponent(
      successUrl
    )}&error=${encodeURIComponent(errorUrl)}`;
  }

  private buildUrl(path: string): string {
    let basePath = this.config.get<string>('basePath', '');
    if (basePath.endsWith('/')) {
      basePath = basePath.substring(0, basePath.length - 1);
    }
    return path.startsWith('/')
      ? `${basePath}/#${path}`
      : `${basePath}/#/${path}`;
  }
}
